import { render, staticRenderFns } from "./DashUserProfile.vue?vue&type=template&id=50e7b713&scoped=true&"
import script from "./DashUserProfile.vue?vue&type=script&lang=ts&"
export * from "./DashUserProfile.vue?vue&type=script&lang=ts&"
import style0 from "./DashUserProfile.vue?vue&type=style&index=0&id=50e7b713&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e7b713",
  null
  
)

export default component.exports